// TOP - mv メインビジュアル
$(window).on("load", function () {
	setTimeout(() => {
		var mySwiper = new Swiper('.js-slider--main', {
			slidesPerView: 1,
			loop: true,
			effect: 'fade',
			autoplay: {
				delay: 3000,
			},
		})
	}, 900);
});

$(window).on("load", function () {
	setTimeout(() => {
		var mySwiper = new Swiper('.js-slider--movie', {
			loop: true,
			effect: 'slide',
			speed: 1000,
			centeredSlides: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			autoplay: {
				delay: 4000,
			},
			breakpoints: {
				1: {
					slidesPerView: 1.12,
					spaceBetween: 60,
				},
				767: {
					slidesPerView: 2.5,
					spaceBetween: 60,
				}
			}
		})
	}, 900);
	// ナビゲーション用に取得
	windowSize();

	// リサイズ時の処理
	$(window).on("resize", function () { windowSize(); });


	// 処理内容
	function windowSize() {
		setTimeout(() => {
			// 横幅と高さを変数に代入
			var swpier__width = $(".js-slider--movie .card-box__img").outerWidth();
			var swpier__height = $(".js-slider--movie .card-box__img").outerHeight();

			// 横幅と高さを表示
			$(".js-slider--movie .js-slider--movie__nav").css('width', swpier__width);
			$(".js-slider--movie .js-slider--movie__nav").css('height', swpier__height);
			$(".js-slider--movie .js-slider--movie__nav").css('margin-bottom', -(swpier__height));
		}, 1000);
	}

	setTimeout(() => {
		$('.slider_modal_iframe').modaal({

			type: 'video'
		});
	}, 1100);

});

var mySwiper = new Swiper('.c-slider--gallery__container', {
	loop: true,
	effect: 'slide',
	speed: 2000,
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		767: {
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
		},
		// ウィンドウサイズが640px以下
		1920: {
			slidesPerView: 2.5,
			spaceBetween: 20

		}
	}
})
